import {Button,Dialog,DialogActions,DialogContent,DialogTitle} from "@mui/material";
import React from "react";
import Text from "./Text";

export default function AddResourceDialog(props) {
    const { open, setOpen, title, setValue, defaultName } = props;
    const [name, setName] = React.useState("");
    const [link, setLink] = React.useState("");
 
  return (
    <Dialog open={open} fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <div
          style={{
            display: "flex",
            gap: 10,
            flexDirection: "column",
            padding: 10,
          }}
        >
          <Text
            value={name}
            label="name"
            setValue={setName}
          />
          <Text
            value={link}
            label="link"
            setValue={setLink}
          />
        </div>
      </DialogContent>
      <DialogActions>
        <Button
          color="error"
          onClick={() => setOpen(false)}
        >
          Close
        </Button>
              <Button color="success" onClick={() => {
            setValue({ name: name ? name : defaultName, link });
            setOpen(false);
            setName("");
            setLink("");
        }}>Go</Button>
      </DialogActions>
    </Dialog>
  );
}